/*
 * @Author:
 * @LastEditTime: 2024-09-11 16:24:01
 * @Description: 入口文件
 */
import 'windi.css'
// import '@/assets/styles/index.scss'
// eslint-disable-next-line
import 'codemirror/lib/codemirror.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@wiz-core/theme/dist/index.css'

import Vue from 'vue'
import dayjs from 'dayjs'
import ELEMENT from 'element-ui'
import _ from 'lodash'
import localforage from 'localforage'
import $echarts from 'echarts'
import Echarts from 'vue-echarts/components/ECharts'
import echartThemes from '@/assets/echarts-theme'
import 'echarts-liquidfill'
import 'echarts-gl'
import 'xe-utils'
import { codemirror } from 'vue-codemirror'
import VXETable from 'vxe-table'
import commonHandler from '@/assets/js/commonHandler'
import router from '@/router/create'
import store from '@/models/create'
import commonDirectives from '@/directives/common'
import '@/assets/js/common/common'
import 'vxe-table/lib/style.css'
import uploader from 'vue-simple-uploader'
import './directives/el-drag-dialog/drag'
import './directives/scroll-hide-select'
import './directives/highlight'
import { Wiz, loadSettings, StartWizService, ApiClient } from '@wiz-core/core'
import wizComps from '@wiz-core/compts/lib/index'
import i18n from './i18n'
import App from './App_mock'

Object.keys(echartThemes).forEach((key) => {
  Echarts.registerTheme(key, echartThemes[key])
})

Vue.use(wizComps)
Vue.use(codemirror)
Vue.use(uploader)
Vue.component('v-chart', Echarts)

// 批量注册指令
Object.keys(commonDirectives).forEach((directive) => {
  Vue.directive(directive, commonDirectives[directive])
})
Vue.use(VXETable)
Vue.use(commonHandler)
const currentEnv = _.cloneDeep(process.env)
currentEnv.DEBUG = currentEnv.VUE_APP_DEBUG === 'true'
Vue.config.devtools = currentEnv.DEBUG
Vue.config.productionTip = !currentEnv.DEBUG
dayjs.locale('zh-cn')
localforage.setDriver(localforage.LOCALSTORAGE)

const init = async () => {
  Wiz.ApiClient = ApiClient
  console.log(Wiz.ApiClient)
  await loadSettings(Wiz)
  Wiz.inject(router, store)
  await StartWizService(Wiz)

  _.assign(Vue.prototype, {
    _,
    dayjs,
    currentEnv,
    $echarts,
  })
  Vue.use(ELEMENT, {
    i18n: (key, value) => {
      return i18n.t(key, value)
    },
  })
  const app = new Vue({
    router,
    store,
    i18n,
    render: (h) => {
      return h(App)
    },
  }).$mount('#app')

  _.assign(window, {
    app,
    $echarts,
  })
}
init()
// // 模型中心配置
// currentEnv.modelSetting
Vue.prototype.$pageSizeAll = [15, 30, 50, 100, 200]
Vue.prototype.$hasAccess = function hasAccess(name) {
  // 默认从路由获取
  let operations = this.$route.meta.operations
  const pageTags = Wiz.store.getters['System/pageTags']
  if (pageTags) {
    const currentTag = _.find(pageTags, ['name', this.$route.name])
    // 缓存中取到
    if (currentTag) {
      operations = currentTag.meta.operations
    }
  }
  if (!operations) return true
  return operations[name] && operations[name].access
}

Vue.prototype.$getConfig = function getConfig() {
  // addRoute的过程中赋值
  const moduleName = this.$route.meta.__module_name__
  if (!moduleName) return null
  const gWiz = Wiz
  const inst = gWiz.GetModuleInstance(moduleName)
  if (inst) return inst.config
  return null
}
